const Pagination = ({ page, setPage, count, limit }) => {
  return (
    <div className="row">
      <div className="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start"></div>
      <div className="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end">
        <div
          className="dataTables_paginate paging_simple_numbers"
          id="driver_paginate"
        >
          <ul
            className="pagination flex-nowrap overflow-auto m-0"
            style={{
              whiteSpace: "nowrap",
              WebkitOverflowScrolling: "touch",
              scrollbarWidth: "none",
            }}
          >
            {/* Previous Button */}
            <li
              className={`paginate_button page-item previous ${
                page === 1 ? "disabled" : ""
              }`}
            >
              <span
                style={{ cursor: "pointer" }}
                onClick={() => page > 1 && setPage(page - 1)}
                className="page-link"
              >
                <i className="previous"></i>
              </span>
            </li>

            {(() => {
              const totalPages = Math.ceil(count / limit);
              let pages = [];

              if (totalPages <= 6) {
                pages = Array.from({ length: totalPages }, (_, i) => i + 1);
              } else {
                if (page <= 3) {
                  pages = [1, 2, 3, 4, "...", totalPages];
                } else if (page >= totalPages - 2) {
                  pages = [
                    1,
                    "...",
                    totalPages - 3,
                    totalPages - 2,
                    totalPages - 1,
                    totalPages,
                  ];
                } else {
                  pages = [
                    1,
                    "...",
                    page - 1,
                    page,
                    page + 1,
                    "...",
                    totalPages,
                  ];
                }
              }

              return pages.map((item, index) => (
                <li
                  key={index}
                  onClick={() => typeof item === "number" && setPage(item)}
                  className={
                    item === page
                      ? "paginate_button page-item active"
                      : typeof item === "string"
                      ? "paginate_button page-item disabled"
                      : "paginate_button page-item"
                  }
                >
                  <span
                    style={{
                      cursor: typeof item === "number" ? "pointer" : "default",
                    }}
                    className="page-link"
                  >
                    {item}
                  </span>
                </li>
              ));
            })()}

            {/* Next Button */}
            <li
              className={`paginate_button page-item next ${
                page === Math.ceil(count / limit) ? "disabled" : ""
              }`}
            >
              <span
                style={{ cursor: "pointer" }}
                onClick={() =>
                  Math.ceil(count / limit) > page && setPage(page + 1)
                }
                className="page-link"
              >
                <i className="next"></i>
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
